module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Copyright © 1975 by Jerzy Kosinski")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Published simultaneously in Canada"), _c('br'), _vm._v("Printed in the United States of America"), _c('br'), _vm._v("Originally published by Houghton Mifflin Company")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Kosinski, Jerzy N., 1933-1991.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("     Cockpit / Jerzy Kosinski.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("            p.    cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("     eBook ISBN-13: 978-0-8021-9578-4")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("      I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("   [PS3561.08C6    1998]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("  813’.54—dc21                        98-14019")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6744ad5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 72
// module chunks = 0